module.exports = __webpack_public_path__ + "static/media/Ve.406829ad.jpg";